import React from 'react';
export const CFIconArrowDown = {
    alias: 'arrow-down',
    defaultTitle: 'Arrow Down',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M18.768 13.36a1 1 0 0 0-1.408-.128L13 16.865V5a1 1 0 0 0-2 0v11.865l-4.36-3.633a1 1 0 1 0-1.28 1.536l6 5c.047.04.103.059.155.089.041.024.077.052.122.07A.992.992 0 0 0 12 20a.992.992 0 0 0 .363-.073c.045-.018.081-.046.122-.07.052-.03.108-.049.155-.089l6-5a1 1 0 0 0 .128-1.408Z' }))),
};
